import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import LanguageIcon from '@mui/icons-material/Language';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { setLanguage } from '../../../../../locations/js/actions/locationActions';
import store from '../../../../../locations/js/store';

const SOURCE_LANGUAGE = { code: 'en', name: 'English' };

function LanguageDropdownMenuMobile({ languageChange }) {
  const [allLanguages, setAllLanguages] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState();

  useEffect(() => {
    const live = window.Transifex?.live;

    if (!live) {
      return;
    }

    const initializeLanguages = () => {
      const languageCode = live.getSelectedLanguageCode?.() || 'en';
      const languages = live.getAllLanguages?.() || [];
      const normalizedLanguages =
        languageCode === SOURCE_LANGUAGE.code &&
        !languages.some((language) => language.code === SOURCE_LANGUAGE.code)
          ? [SOURCE_LANGUAGE, ...languages]
          : languages;
      const selected = normalizedLanguages.find((language) => language.code === languageCode);

      setAllLanguages(normalizedLanguages);
      setSelectedLanguage(selected);

      if (selected?.code) {
        store.dispatch(setLanguage(selected.code));
      }
    };

    initializeLanguages();
    live.onReady?.(initializeLanguages);
  }, []);

  const changeLanguage = (language) => {
    if (selectedLanguage?.code !== language.code) {
      window.Transifex?.live?.translateTo?.(language.code);

      setSelectedLanguage(language);
      store.dispatch(setLanguage(language.code));

      if (languageChange) {
        languageChange({
          selectedLanguage: language,
        });
        store.dispatch(setLanguage(language.code));
      }
    }
  };
  const notSelectedLanguages = allLanguages?.filter(
    (language) => selectedLanguage?.name !== language.name
  );
  return (
    <Accordion
      sx={{
        width: '100%',
        '&:before': {
          display: 'none', // removes shadow in accordion
        },
      }}
      elevation={0}
    >
      <AccordionSummary sx={{ boxShadow: 0 }} expandIcon={<ExpandMoreIcon />}>
        <LanguageIcon />
        <Typography sx={{ textTransform: 'uppercase', pl: 1 }}>{selectedLanguage?.name}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {notSelectedLanguages &&
          notSelectedLanguages.map((language) => (
            <MenuItem
              key={language.code}
              onClick={() => changeLanguage(language)}
              sx={{ textTransform: 'uppercase' }}
            >
              {language.name}
            </MenuItem>
          ))}
      </AccordionDetails>
    </Accordion>
  );
}

export default LanguageDropdownMenuMobile;
